import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import './style.scss';
import {useIsAuthenticated} from 'utils/hooks/auth/useUserHasFullAuth';
import useMedia from 'utils/hooks/useMedia';
import {getAnnouncements} from 'store/entities/announcement/thunks';
import NavPrimary from './NavPrimary/';
import NavSecondary from './NavSecondary/';
import Announcements from './Announcements';

const Header = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useIsAuthenticated();

  const isMobile = useMedia(
    ['(max-width: 1023px)', '(min-width: 1px)'],
    [true, false],
    false
  );

  useEffect(() => {
    isAuthenticated && dispatch(getAnnouncements());
  }, [dispatch, isAuthenticated]);

  return (
    <>
      {!isMobile && (
        <Announcements/>
      )}
      <NavPrimary/>
      <NavSecondary/>
      {isMobile && (
        <Announcements/>
      )}
    </>
  );
};

export default Header;
